<h2 mat-dialog-title>Really delete <em>{{ data.name }}</em>?</h2>
<mat-dialog-content>
    <p>The record of this bibliography will be permanently deleted.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close aria-label="cancel deleting {{ data.name }}">Cancel</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial aria-label="delete {{ data.name }}">Delete bibliography</button>
</mat-dialog-actions>